import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "burst-item"
}
const _hoisted_2 = { class: "left-controls" }
const _hoisted_3 = ["id", "checked", "disabled"]
const _hoisted_4 = { class: "tags-container" }
const _hoisted_5 = { class: "duration-rate-container" }
const _hoisted_6 = { class: "plotdl-buttons" }
const _hoisted_7 = {
  key: 1,
  class: "burst-item no-checkbox"
}
const _hoisted_8 = { class: "left-controls" }
const _hoisted_9 = { class: "tags-container" }
const _hoisted_10 = { class: "duration-rate-container" }
const _hoisted_11 = { class: "plotdl-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.toggleBurst !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
              type: "checkbox",
              id: `checkbox-${JSON.stringify(_ctx.burst)}-${_ctx.idModifier}`,
              checked: _ctx.isBurstSelected(_ctx.burst.BurstID),
              onChange: _cache[0] || (_cache[0] = () => _ctx.toggleBurst(_ctx.burst)),
              disabled: _ctx.maxBurstsSelected() && !_ctx.isBurstSelected(_ctx.burst.BurstID)
            }, null, 40, _hoisted_3),
            _createElementVNode("div", null, "Burst " + _toDisplayString(_ctx.burst.BurstID) + ", Sensor " + _toDisplayString(_ctx.burst.SensorName), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topBurstTags, (tag) => {
              return (_openBlock(), _createElementBlock("div", { key: tag }, _toDisplayString(tag), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, _toDisplayString(_ctx.burst.Duration) + " @ " + _toDisplayString(_ctx.burst.SampleRate) + "Hz", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toggleBurst === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, " Batch " + _toDisplayString(_ctx.burst.BatchID) + " Burst " + _toDisplayString(_ctx.burst.BurstID) + ", Sensor " + _toDisplayString(_ctx.burst.SensorName), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topBurstTags, (tag) => {
              return (_openBlock(), _createElementBlock("div", { key: tag }, _toDisplayString(tag), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, _toDisplayString(_ctx.burst.Duration) + " @ " + _toDisplayString(_ctx.burst.SampleRate) + "Hz", 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}